import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDataInput, IInflowTransfer } from '../../../../../../interface/interfaces';

interface IInitialState {
    neo4jResultLoading: boolean;
    neo4jResultData: IInflowTransfer;
    neo4jResultError: string;
}

const initialState: IInitialState = {
    neo4jResultLoading: false,
    neo4jResultData: {},
    neo4jResultError: '',
};

const inFlowTransferSlice = createSlice({
    name: 'inFlowTransferSlice',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchInFlowTransferPeding: (state: IInitialState, action: PayloadAction<IDataInput>) => {
            state.neo4jResultLoading = true;
            state.neo4jResultData = {};
        },
        fetchInFlowTransferFulfilled: (state: IInitialState, action: PayloadAction<IInflowTransfer>) => {
            state.neo4jResultLoading = false;
            state.neo4jResultData = action.payload;
            state.neo4jResultError = '';
        },
        fetchInFlowTransferFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.neo4jResultLoading = false;
            state.neo4jResultData = {};
            state.neo4jResultError = action.payload;
        },
    },
});

export default inFlowTransferSlice.reducer;
export const { fetchInFlowTransferPeding, fetchInFlowTransferFulfilled, fetchInFlowTransferFailure } = inFlowTransferSlice.actions;
